import React, { Component } from 'react'

export default class WXMinProgram extends Component {
  componentDidMount() {
    window.location.href =
      'https://a.app.qq.com/o/simple.jsp?pkgname=com.ihealth.HuTang'
  }
  render() {
    return <div>正在转向到下载页面，请稍等...</div>
  }
}



// WEBPACK FOOTER //
// ./src/modules/wxProgram/index.js